module.exports = __webpack_public_path__ + "img/44.c3aa9f9e.png";